<template>
  <div v-if="this.language == 'eng'">
    <waterfall :col="col" :data="data">
      <template>
        <div
          class="cell-item wow animate__fadeInDown animate__animated"
          @click="goDetail(item.id)"
          v-for="(item, index) in data"
          :key="index"
        >
          <img
            v-if="item.picture.length>0"
            :src="url + item.picture[0].fileUrl"
            alt="加载错误"
          />
          <img v-else src="" alt="" />
          <div class="item-body">
            <div class="item-desc">{{ item.title }}</div>
            <div class="item-footer">
              <div class="footer-left">
                <img
                  v-if="item.authorPicture"
                  :src="url + item.authorPicture.fileUrl"
                  alt="加载错误"
                />
                <!-- <span v-else>暂无图片</span> -->
                <div class="circle" v-else></div>
                <div class="name">{{ item.englishName }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </waterfall>
  </div>
  <div v-else-if="this.language == 'en'">
    <waterfall :col="col" :data="data">
      <template>
        <div
          class="cell-item wow animate__fadeInDown animate__animated"
          @click="goDetail(item.id)"
          v-for="(item, index) in data"
          :key="index"
        >
          <img
            v-if="item.picture.length>0"
            :src="url + item.picture[0].fileUrl"
            alt="ཁུར་སྣོན་ནོར་འཁྲུལ།"
          />
          <img v-else src="" alt="" />
          <div class="item-body">
            <div class="item-desc">{{ item.title }}</div>
            <div class="item-footer">
              <div class="footer-left">
                <img
                  v-if="item.authorPicture"
                  :src="url + item.authorPicture.fileUrl"
                  alt="ཁུར་སྣོན་ནོར་འཁྲུལ།"
                />
                <!-- <span v-else>གནས་སྐབས་པར་རིས་མེད་།</span> -->
                <div class="circle" v-else></div>
                <div class="name">{{ item.zangName }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </waterfall>
  </div>
  <div v-else>
    <waterfall :col="col" :data="data">
      <template>
        <div
          class="cell-item wow animate__fadeInDown animate__animated"
          @click="goDetail(item.id)"
          v-for="(item, index) in data"
          :key="index"
        >
          <img
            v-if="item.picture.length>0"
            :src="url + item.picture[0].fileUrl"
            alt="加载错误"
          />
          <img v-else src="" alt="" />
          <div class="item-body">
            <div class="item-desc">{{ item.title }}</div>
            <div class="item-footer">
              <div class="footer-left">
                <img
                  v-if="item.authorPicture"
                  :src="url + item.authorPicture.fileUrl"
                  alt="加载错误"
                />
                <!-- <span v-else>暂无图片</span> -->
                <div class="circle" v-else></div>
                <div class="name">{{ item.chineseName }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </waterfall>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      url: process.env.VUE_APP_WEB_URL,
      col: 2,
      language: this.$store.state.language,
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  mounted() {
    new this.$wow.WOW().init();
  },
  created() {},
  methods: {
    goDetail(id) {
      this.$router.push({ path: "/dataBaseDetail", query: { id: id } });
    },
  },
};
</script>
<style lang="scss">
@media (max-width: 768px) {
  .vue-waterfall-column {
    .cell-item {
      padding: 0;
      margin: 0.3rem 0 !important;
      box-shadow: none !important;
      .item-body {
        margin: 0.2rem 0 !important;
        .item-footer {
          .footer-left {
            width: 100%;
            img {
              border-radius: 0.6rem;
              width: 0.6rem !important;
              height: 0.6rem !important;
              margin-right: 0.1rem !important;
            }
            .circle {
              margin-right: 0.1rem !important;
              border-radius: 0.6rem;
              width: 0.6rem !important;
              height: 0.6rem !important;
              border: 1px solid #e9e9e9;
            }
            .name {
              width: calc(100% - .7rem)!important;
              font-size: 0.25rem!important;
              text-overflow: ellipsis;
              overflow: hidden; /* 文本超出的部分隐藏 */
              display: -webkit-box;/* 弹性伸缩盒模型显示 */
              -webkit-line-clamp: 1;/* 限制在一个块元素中显示文本的行数 */
              -webkit-box-orient: vertical;/* 设置伸缩盒子对象的子元素的排列方式 */
            }
          }
        }
      }
    }
  }
}
</style>